function trackBookingStep() {
    if (!window.mixpanel) return;

    mixpanel.track('Front-end booking form', {
        step: 'services',
        version: 'pro',
        layout: 'large',
        environment: 'live'
    });
}

document.addEventListener('DOMContentLoaded', trackBookingStep);